import { getLinks } from "../../../../shared/functions/fns.nav";
import Loader from "@phoenixreisen/reacts/src/loader";
import React, { useEffect, useState } from "react";
export const ExternNav = (props) => {
    const [links, setLinks] = useState(props.links || null);
    const [error, setError] = useState(props.error || null);
    useEffect(() => {
        if (!props.links && !props.error) {
            getLinks()
                .then((links) => setLinks(links))
                .catch((e) => setError(new Error(e)));
        }
    }, []);
    if (!links && !error) {
        return (React.createElement("div", { className: "tc mt4" },
            React.createElement(Loader, { text: "Links werden geladen..." })));
    }
    if (error) {
        return (React.createElement("div", { className: "alert alert--danger alert--icon mt3" },
            React.createElement("i", { className: "fas fa-times" }),
            "Links konnten nicht geladen werden. Bitte Seite erneut laden."));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null, "Weitere Pr\u00E4senzen"),
        React.createElement("ul", null, links.PUBLIC.map((link, index) => (React.createElement("li", { key: index },
            React.createElement("a", { href: link.href },
                React.createElement("i", { className: "fas fa-angle-right mr2" }),
                link.name)))))));
};
export default ExternNav;
